export default "__VITE_ASSET__CZyUSk8H__"